module.exports = __webpack_public_path__ + "static/img/6.1bf9a68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/6.png
// module id = EYdW
// module chunks = 1